<template>
  <div class="wrap">
    <div class="wrapNav">
      <p class="wrapNavTitle">ISC大会介绍</p>
      <p class="wrapNavDesc">INTERNET SECURITY CONFERENCE</p>
      <div class="wrapNavList">
        <div class="left">
          {{ nav.desc }}
          <ul class="leftList" v-if="nav.list">
            <li class="leftListLi" v-for="item in nav.list" :key="item.id">
              <span class="leftListLiTitle">{{ item.title }}</span>
              <span class="leftListLiDesc">{{ item.desc }}</span>
            </li>
          </ul>
        </div>
        <div class="right">
          <img :src="nav.pic" alt="内容宣传图" class="rightImg" />
          <p class="rightTitle">{{ nav.title }}</p>
          <p class="rightTitleS">{{ nav.title_small }}</p>
        </div>
        <Btn :navArr="IscAbout_2023" :style="styleBtn" @fetchNav="fetchNav" />
      </div>
    </div>
  </div>
</template>

<script setup>
import { IscAbout_2023 } from '@/mock/2023isc/data.js'
import { ref } from 'vue'
import Btn from '@/components/common/2023/button.vue'
const styleBtn = {
  position: 'absolute',
  right: '20px',
  top: '406px'
}
const nav = ref(IscAbout_2023[0])
function fetchNav(newId) {
  nav.value = IscAbout_2023[newId]
}
</script>

<style lang="scss" scoped>
.clear {
  margin: 0;
}
body {
  background: #f7f8fc;
}
.wrap {
  width: 100%;
  min-width: 1280px;
  padding: 80px 0 66px;
  background: url('https://p2.ssl.qhimg.com/t01771b149917a34d61.png') no-repeat;
  background-size: cover;
  &Nav {
    width: 1280px;
    margin: 0 auto;
    &Title {
      font-size: 40px;
      font-weight: bold;
      line-height: 32px;
      color: #00ab7a;
      margin: 0;
    }
    &Desc {
      font-size: 28px;
      line-height: 32px;
      color: #3d3d3d;
      margin: 12px 0 40px;
    }
    &List {
      position: relative;
      display: flex;
      justify-content: space-between;
      height: 500px;
      background-color: #fff;
      .left {
        flex: 1;
        padding: 30px 24px;
        font-size: 16px;
        line-height: 32px;
        color: #3d3d3d;
        &List {
          width: 576px;
          border-radius: 4px;
          background: #f5f6fa;
          margin-top: 16px;
          padding: 24px 16px;
          &Li {
            list-style: none;
            font-size: 16px;
            line-height: 24px;
            margin-bottom: 16px;
            &Title {
              font-weight: bold;
              color: #00ab7a;
            }
          }
          &Li:last-child {
            margin-bottom: 0;
          }
        }
      }
      .right {
        flex: 1;
        font-size: 16px;
        line-height: 32px;
        color: #3d3d3d;

        &Img {
          display: inline-block;
          width: 656px;
          height: 366px;
        }
        &Title {
          margin: 35px 0 8px;
          font-size: 20px;
          line-height: 26px;
          font-weight: bold;
        }
      }
    }
  }
}
</style>
